// hooks/useAssetReport.ts
import {ConvertZDateOnly } from "../../helpers/helperFunctions";
import { useState, useCallback, useRef, useEffect } from 'react';
import axios from 'axios';
import { AssetReportFilters, AssetReportRow } from './types';
import configs from '../../../configs/config';
import moment from "moment";
// import { DEFAULT_FILTERS, AssetReportFilters, AssetReportRow } from './types';
const AssetUrl = `${configs?.BASE_URL}/AssetCSVReport/GetAssetCSVReport`;

export const useAssetReport = () => {
  const [rows, setRows] = useState<AssetReportRow[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const abortControllerRef = useRef<AbortController | null>(null);

  const fetchReport = useCallback(async (filters: AssetReportFilters) => {
    // Cancel previous request
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    abortControllerRef.current = new AbortController();
    setLoading(true);
    setError(null);

    try {
      const response = await axios.post(
        AssetUrl,
        {
          ...filters,
          startDate: moment(filters.startDate).format("YYYY-MM-DD"),
          endDate: moment(filters.endDate).format("YYYY-MM-DD"),
          pageNumber: 1,
          pageSize: 10000, // Adjust as needed
        },
        { signal: abortControllerRef.current.signal } as any
      );
      const filteredData = response?.data.map((asset:any) => {
        const row = {...asset};
            Object.entries(row).forEach(([key, value]) => {
            if ( typeof value === "string" && value && !isNaN(Date.parse(value as string))) {
              row[key] = ConvertZDateOnly(value);
            }
          });
          return row
      })
      setRows(filteredData);
      return filteredData;
    } catch (err: any) {
      if (err.name !== 'AbortError') {
        setError(err.message || 'Failed to fetch report');
        console.error('Error generating CSV:', err);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      abortControllerRef.current?.abort();
    };
  }, []);

  return { rows, loading, error, fetchReport };
};